import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faXmark } from '@fortawesome/pro-light-svg-icons';

export type ProLightXmarkProps = IconComponentProps;

export const ProLightXmark = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightXmarkProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faXmark}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faXmark}
    />
  );
};

ProLightXmark.displayName = 'ProLightXmark';
